// extracted by mini-css-extract-plugin
export default {"style":"DropdownSelect_style__di94v","dropdownStyle":"DropdownSelect_dropdownStyle__FoxUk"};